<template>
    <div class="report-container">
      <h1>Inventory Value Report</h1>
      
      <!-- Filters -->
      <!-- Load Report -->
<div class="filters">
  <button @click="fetchReport" class="add-button">Generate Report</button>
</div>

      
      <!-- Report Table -->
      <div class="table-container">
        <table class="report-table">
          <thead>
            <tr>
              <th class="left-align">Category</th>
              
              <th class="right-align">Total Inventory Value</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in reportData" :key="item.category">
              <td class="left-align">{{ item.category }}</td>
              
              <td class="right-align">${{ formatNumber(item.total_inventory_value) }}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td class="left-align"><strong>Grand Total</strong></td>
              <td class="right-align"><strong>${{ formatNumber(totalInventoryValue) }}</strong></td>
            </tr>
          </tfoot>


        </table>
      </div>
    </div>
  </template>
  
  <script>
  import api from '@/services/api';
  
  export default {
    data() {
      return {
        reportData: [],
        totalInventoryValue: 0
        
      };
    },
    methods: {
      async fetchCategories() {
        try {
          const response = await api.get('/inventory');
          const uniqueCategories = [...new Set(response.data.map(item => item.category_name).filter(Boolean))];
          this.categories = uniqueCategories;
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
      },
      async fetchReport() {
        try {
          const response = await api.get('/reports/inventory-value');
          this.reportData = response.data;

          const totalResponse = await api.get('/reports/inventory-value-total');
          this.totalInventoryValue = totalResponse.data.total_inventory_value;
        } catch (error) {
          console.error('Error fetching Inventory Value report:', error);
        }
      },

      formatNumber(value) {
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    mounted() {
      this.fetchCategories();
    }
  };
  </script>
  
  <style scoped>
  /* General Container */
  .report-container {
    padding: 20px;
    font-family: "Poppins", sans-serif !important;
    background: #9cd0f2; /* Light grey-blue */
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    margin: 0 auto;
  }
  
  .table-container {
    background: #eef4fb;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  /* Filters & Inputs */
  .filters {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .search-input {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #b0c4de;
    background: #e6eef3;
  }
  
  /* Buttons */
  .add-button {
    background-color: #288671;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
  }
  
  .add-button:hover {
    background-color: #237a4b;
  }
  
  /* Tables */
  .report-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  
  .report-table th, .report-table td {
    border: 1px solid #83a7cb;
    padding: 8px;
  }
  
  .report-table th {
    background: #e6eef3;
    text-align: left;
  }
  
  .report-table tr:hover {
    background-color: #e0f2f1;
  }
  
  /* Left-align the Report Line column */
  .left-align {
    text-align: left;
  }
  
  /* Right-align the Amount column */
  .right-align {
    text-align: right;
  }
  </style>
  